import {createSlice} from "@reduxjs/toolkit";

const initialUsersState = {
  actionsLoading: false,
  businessUsersList: []
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const usersSlice = createSlice({
  name: "users",
  initialState: initialUsersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // Set State Method
    setState: (state, action) => {

      if(action.payload.hasOwnProperty("user_list")){
          state.businessUsersList = action.payload.user_list
      }

    }
  }
});
